<template>
  <a-modal
      title="添加小程序"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      :afterClose="afterClose"
      destroyOnClose
  >
    <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="消息标题" prop="name">
        <a-input :size="$globalSize" v-model="form.name"/>
      </a-form-model-item>
      <a-form-model-item label="小程序选择" prop="microAppObj">
        <a-select :size="$globalSize" v-model="form.microAppObj"  label-in-value>
          <a-select-option v-for="item in microAppList" :value="item.appId" :key="item.appId">
            {{ item.appName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳转地址" prop="address">
        <a-input :size="$globalSize" v-model="form.address"/>
      </a-form-model-item>
      <a-form-model-item label="消息封面" prop="material">
        <upload-img ref="posterUploadRef" :multiple="false" v-model="form.material"
                    @initStep="()=>{}" @previewDataChange="()=>{}"></upload-img>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";
import uploadImg from "@/views/material/components/uploadImg";
import materialUpload from "@/interface/pages/material/materialUpload";

export default {
  name: "addMicroAppModal",
  components: {
    uploadImg
  },
  props: {},

  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      form: {
        name:'',
        microAppObj:'',
        address:'',
        material:''
      },
      rules: {
        name: [
          {required: true, message: '请输入标题', trigger: 'change'}
        ],
      },
      microAppList:[]
    };
  },
  mounted() {
    this.getWeChatMiniProgramName()
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal() {
      this.visible = true;
    },
    submit() {
      this.$refs.ruleForm.validate(async valid=>{
        if(!valid)return false
        this.$emit('sync',{...this.form,type:'miniPro',url:this.form.material.url,microApp:this.form.microAppObj.key})
        this.visible = false
      })
    },
    async getWeChatMiniProgramName(){
      const {data: res} = await materialUpload.getWeChatMiniProgramName(this, {})
            try{
              if (res.code === '200') {
                this.microAppList = res.data
              } else {
                this.$message.error(res.message)
              }
            }catch(e){
              console.log(e)
            }
    },
    afterClose() {
      this.form = {
        name:'',
        microAppObj:'',
        address:'',
        material:''
      }
    }
  },
};
</script>

<style scoped lang="less">

</style>
